import { FC } from 'react';
import { GameCardContainerType } from '../../GameCard/GameCard.types';
import { Grid, GridItem } from '../../../shared/Grid';
import { useBreakpointInfo, MediaBreakpoint } from '../../../../hooks/useDeviceInfo';
import { renderGameCard, BaseLayoutProps } from '../utils';
// import { GRID_LAYOUT_GAMES_COUNT } from '../../../../utils/games/createTileRowCollections';

type GridLayoutProps = BaseLayoutProps;

export const GridLayout: FC<GridLayoutProps> = ({ games, getCompositeKey, ...props }) => {
  const isMobileDevice = useBreakpointInfo([MediaBreakpoint.BELOW_MID_DESKTOP]);

  if (games.length === 0) return null;

  if (isMobileDevice) {
    return (
      <Grid columns={2} gap="s" className="game-grid game-grid--grid-mobile">
        {games.map((game, index) => (
          <GridItem key={getCompositeKey(game, `grid-mobile-${index}`)}>
            {renderGameCard(game, GameCardContainerType.Box, `grid-mobile-${index}`, props)}
          </GridItem>
        ))}
      </Grid>
    );
  }

  return (
    <Grid columns={2} gap="s" className="game-grid game-grid--grid">
      {games.map((game, index) => (
        <GridItem key={getCompositeKey(game, `grid-${index}`)}>
          {renderGameCard(game, GameCardContainerType.Box, `grid-${index}`, props)}
        </GridItem>
      ))}
    </Grid>
  );
};
